<template>
  <v-card class="change-store">
    <v-card-title class="change-store__close pa-0 py-3">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon
          medium
        >
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="change-store__title pa-0 mb-2">
      Você está trocando de loja?
    </v-card-text>

    <v-card-text class="change-store__content pa-0 mb-4">
      {{
        hasProductsOnCart ?
          'A sua seleção será zerada e você irá visualizar os produtos disponíveis na loja selecionada.' :
          'A sua visualização será apenas dos produtos disponíveis na loja selecionada.'
      }}
    </v-card-text>

    <v-card-actions class="ma-0 pa-0 change-store__actions">
      <v-btn
        depressed
        dark
        color="#140C22"
        class="change-store__btn mb-3"
        @click="clearCartAndChangeStore"
      >
        Confirmar troca
      </v-btn>
      <v-btn
        depressed
        outline
        color="#140C22"
        class="change-store__btn ma-0"
        @click="close"
      >
        Não quero trocar a loja
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    changeStore: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['getCatalogue', 'getProducts']),
    hasProductsOnCart() {
      return !!this.getCatalogue.length
        || this.getProducts.some((p) => p.checkbox);
    },
  },
  methods: {
    clearCartAndChangeStore() {
      this.$store.dispatch('clearCheckout');
      this.changeStore();
      this.close();

      if (['personalizar', 'catalogo'].includes(this.$route.name)) {
        this.$router.push('/produtos');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.change-store {
  width: 100%;
  text-transform: none;
  border-radius: 7px;
  padding: 0 40px 40px;
  &__title {
    font: 700 20px/27px 'Nunito Sans';
    color: #140C22;
  }
  &__content {
    font: 400 16px/22px 'Nunito Sans';
    color: #140C22;
  }
  &__actions {
    display: flex;
    flex-flow: column wrap;
  }
  &__btn {
    font: 600 14px 'Nunito Sans';
    width: 100%;
    height: 38px;
    padding: 12px 24px;
    border-radius: 7px;
    text-transform: none;
  }
  &__close {
    position: relative;
    right: -25px;
    display: flex;
    justify-content: end;
  }
}
</style>
